<template>
	<div class="ReportFilter">
		<div class="ReportFilter-current">
			<span class="ReportFilter-current-label">{{ $t('tripReport.personFilterLabel') }}</span>
			<!-- <span class="ReportFilter-current-value">{{ selectedPersonLabel }}</span> -->
		</div>
		<div class="ReportFilter-change">
			<CloDropdown v-bind="$props">
				<template #heading>
					<!-- {{ $t('generic.Change') }} -->
					<span class="u-text-4">{{ selectedPersonLabel }}</span>
				</template>
				<template #panel>
					<ul>
						<li>
							<a :href="`${baseUrl}tripreport/${tripReportId}${viewParam}`" :class="selectedPersonId ? '' : 'current'">{{
								$t('tripReport.groupFilter')
							}}</a>
						</li>
						<li v-for="person in confirmedPeople" :key="person.tripReportPersonId">
							<a
								:href="`${baseUrl}tripreport/${tripReportId}/${person.tripReportPersonId}${viewParam}`"
								:class="selectedPersonId == person.tripReportPersonId ? 'current' : ''"
								>{{ person.userDisplayName }}</a
							>
						</li>
					</ul>
				</template>
			</CloDropdown>
		</div>
	</div>
</template>

<script>
import CloHeading from '@/base/CloHeading/CloHeading.vue';
import CloButton from '@/base/CloButton/CloButton.vue';
import CloDropdown from '@/base/CloDropdown/CloDropdown.vue';

export default {
	name: 'ReportFilter',
	components: {
		CloHeading,
		CloButton,
		CloDropdown,
	},
	props: {
		tripReportId: Number,
		confirmedPeople: Array,
		selectedPersonId: {
			type: Number,
			default: null,
		},
		currentView: {
			type: String,
			default: 'species',
		},
	},
	data() {
		return {
			baseUrl: window.baseUrl,
		};
	},
	methods: {},
	computed: {
		selectedPersonLabel() {
			let label = this.$i18n.t('tripReport.groupFilter');
			if (this.selectedPersonId) {
				let person = this.confirmedPeople.filter((person) => {
					return person.tripReportPersonId === this.selectedPersonId;
				});
				label = person[0].userDisplayName;
			}
			return label;
		},
		viewParam() {
			if (this.currentView !== 'species') {
				return '?view=' + this.currentView;
			}
			return '';
		},
	},
};
</script>

<style lang="scss">
.ReportFilter {
	display: flex;
	align-items: baseline;
	gap: $space-xs;
}
.ReportFilter-current {
	display: flex;
	align-items: baseline;
	gap: $space-sm;
	.ReportFilter-current-label {
		color: $color-text-muted;
		text-transform: uppercase;
		@include text(3);
	}
	.ReportFilter-current-value {
		font-weight: bold;
		@include text(4);
	}
}

.ReportFilter .Dropdown {
	.Dropdown-heading {
		font-weight: bold;
		margin: 0;
	}
	.Dropdown-panel {
		ul {
			list-style: none;
			margin: 0;
			li {
				margin: 0;
			}
		}
		a.current {
			color: $color-black;
		}
	}
}

.print {
	.ReportFilter {
		.Dropdown-heading {
			color: $color-text;
		}
		.Icon--triangleDown {
			display: none;
		}
	}
}
</style>
